// extracted by mini-css-extract-plugin
export var actionButton = "_b3-0";
export var attachmentLine = "_b3-1";
export var fileInput = "_b3-2";
export var fileUploadWrapper = "_b3-4";
export var footer = "_b3-3";
export var modalContent = "_b3-5";
export var paperclip = "_b3-6";
export var quillEditor = "_b3-7";